// automatically generated by the FlatBuffers compiler, do not modify

import * as NS115100186165309685 from "./Types";
import * as NS6954492148246722841 from "./Trace";
import * as NS16181432830625808258 from "./Resource";
/**
 * @enum {number}
 */
export namespace com.tableausoftware.endeavour.protocol.v1.api{
export enum AttributeScrubbingMethod{
  Mask= 0,
  Drop= 1
}};

/**
 * @constructor
 */
export namespace com.tableausoftware.endeavour.protocol.v1.api{
export class PostSpansRequest {
  bb: flatbuffers.ByteBuffer|null = null;

  bb_pos:number = 0;
/**
 * @param number i
 * @param flatbuffers.ByteBuffer bb
 * @returns PostSpansRequest
 */
__init(i:number, bb:flatbuffers.ByteBuffer):PostSpansRequest {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param PostSpansRequest= obj
 * @returns PostSpansRequest
 */
static getRootAsPostSpansRequest(bb:flatbuffers.ByteBuffer, obj?:PostSpansRequest):PostSpansRequest {
  return (obj || new PostSpansRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param PostSpansRequest= obj
 * @returns PostSpansRequest
 */
static getSizePrefixedRootAsPostSpansRequest(bb:flatbuffers.ByteBuffer, obj?:PostSpansRequest):PostSpansRequest {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new PostSpansRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param com.tableausoftware.endeavour.protocol.v1.resource.Resource= obj
 * @returns com.tableausoftware.endeavour.protocol.v1.resource.Resource|null
 */
resource(obj?:NS16181432830625808258.com.tableausoftware.endeavour.protocol.v1.resource.Resource):NS16181432830625808258.com.tableausoftware.endeavour.protocol.v1.resource.Resource|null {
  var offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? (obj || new NS16181432830625808258.com.tableausoftware.endeavour.protocol.v1.resource.Resource()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
};

/**
 * @param number index
 * @param com.tableausoftware.endeavour.protocol.v1.trace.Span= obj
 * @returns com.tableausoftware.endeavour.protocol.v1.trace.Span
 */
spans(index: number, obj?:NS6954492148246722841.com.tableausoftware.endeavour.protocol.v1.trace.Span):NS6954492148246722841.com.tableausoftware.endeavour.protocol.v1.trace.Span|null {
  var offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? (obj || new NS6954492148246722841.com.tableausoftware.endeavour.protocol.v1.trace.Span()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
};

/**
 * @returns number
 */
spansLength():number {
  var offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
};

/**
 * @param flatbuffers.Builder builder
 */
static startPostSpansRequest(builder:flatbuffers.Builder) {
  builder.startObject(2);
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Offset resourceOffset
 */
static addResource(builder:flatbuffers.Builder, resourceOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, resourceOffset, 0);
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Offset spansOffset
 */
static addSpans(builder:flatbuffers.Builder, spansOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, spansOffset, 0);
};

/**
 * @param flatbuffers.Builder builder
 * @param Array.<flatbuffers.Offset> data
 * @returns flatbuffers.Offset
 */
static createSpansVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (var i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]);
  }
  return builder.endVector();
};

/**
 * @param flatbuffers.Builder builder
 * @param number numElems
 */
static startSpansVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
};

/**
 * @param flatbuffers.Builder builder
 * @returns flatbuffers.Offset
 */
static endPostSpansRequest(builder:flatbuffers.Builder):flatbuffers.Offset {
  var offset = builder.endObject();
  return offset;
};

static createPostSpansRequest(builder:flatbuffers.Builder, resourceOffset:flatbuffers.Offset, spansOffset:flatbuffers.Offset):flatbuffers.Offset {
  PostSpansRequest.startPostSpansRequest(builder);
  PostSpansRequest.addResource(builder, resourceOffset);
  PostSpansRequest.addSpans(builder, spansOffset);
  return PostSpansRequest.endPostSpansRequest(builder);
}
}
}
/**
 * @constructor
 */
export namespace com.tableausoftware.endeavour.protocol.v1.api{
export class GetPipelineConfigurationRequest {
  bb: flatbuffers.ByteBuffer|null = null;

  bb_pos:number = 0;
/**
 * @param number i
 * @param flatbuffers.ByteBuffer bb
 * @returns GetPipelineConfigurationRequest
 */
__init(i:number, bb:flatbuffers.ByteBuffer):GetPipelineConfigurationRequest {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param GetPipelineConfigurationRequest= obj
 * @returns GetPipelineConfigurationRequest
 */
static getRootAsGetPipelineConfigurationRequest(bb:flatbuffers.ByteBuffer, obj?:GetPipelineConfigurationRequest):GetPipelineConfigurationRequest {
  return (obj || new GetPipelineConfigurationRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param GetPipelineConfigurationRequest= obj
 * @returns GetPipelineConfigurationRequest
 */
static getSizePrefixedRootAsGetPipelineConfigurationRequest(bb:flatbuffers.ByteBuffer, obj?:GetPipelineConfigurationRequest):GetPipelineConfigurationRequest {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new GetPipelineConfigurationRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param com.tableausoftware.endeavour.protocol.v1.resource.Resource= obj
 * @returns com.tableausoftware.endeavour.protocol.v1.resource.Resource|null
 */
resource(obj?:NS16181432830625808258.com.tableausoftware.endeavour.protocol.v1.resource.Resource):NS16181432830625808258.com.tableausoftware.endeavour.protocol.v1.resource.Resource|null {
  var offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? (obj || new NS16181432830625808258.com.tableausoftware.endeavour.protocol.v1.resource.Resource()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
};

/**
 * @param flatbuffers.Builder builder
 */
static startGetPipelineConfigurationRequest(builder:flatbuffers.Builder) {
  builder.startObject(1);
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Offset resourceOffset
 */
static addResource(builder:flatbuffers.Builder, resourceOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, resourceOffset, 0);
};

/**
 * @param flatbuffers.Builder builder
 * @returns flatbuffers.Offset
 */
static endGetPipelineConfigurationRequest(builder:flatbuffers.Builder):flatbuffers.Offset {
  var offset = builder.endObject();
  return offset;
};

static createGetPipelineConfigurationRequest(builder:flatbuffers.Builder, resourceOffset:flatbuffers.Offset):flatbuffers.Offset {
  GetPipelineConfigurationRequest.startGetPipelineConfigurationRequest(builder);
  GetPipelineConfigurationRequest.addResource(builder, resourceOffset);
  return GetPipelineConfigurationRequest.endGetPipelineConfigurationRequest(builder);
}
}
}
/**
 * @constructor
 */
export namespace com.tableausoftware.endeavour.protocol.v1.api{
export class SpanCondition {
  bb: flatbuffers.ByteBuffer|null = null;

  bb_pos:number = 0;
/**
 * @param number i
 * @param flatbuffers.ByteBuffer bb
 * @returns SpanCondition
 */
__init(i:number, bb:flatbuffers.ByteBuffer):SpanCondition {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param SpanCondition= obj
 * @returns SpanCondition
 */
static getRootAsSpanCondition(bb:flatbuffers.ByteBuffer, obj?:SpanCondition):SpanCondition {
  return (obj || new SpanCondition()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param SpanCondition= obj
 * @returns SpanCondition
 */
static getSizePrefixedRootAsSpanCondition(bb:flatbuffers.ByteBuffer, obj?:SpanCondition):SpanCondition {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new SpanCondition()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param flatbuffers.Encoding= optionalEncoding
 * @returns string|Uint8Array|null
 */
spanName():string|null
spanName(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
spanName(optionalEncoding?:any):string|Uint8Array|null {
  var offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
};

/**
 * @param number index
 * @param com.tableausoftware.endeavour.protocol.v1.types.StringKeyAnyValue= obj
 * @returns com.tableausoftware.endeavour.protocol.v1.types.StringKeyAnyValue
 */
customAttributes(index: number, obj?:NS115100186165309685.com.tableausoftware.endeavour.protocol.v1.types.StringKeyAnyValue):NS115100186165309685.com.tableausoftware.endeavour.protocol.v1.types.StringKeyAnyValue|null {
  var offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? (obj || new NS115100186165309685.com.tableausoftware.endeavour.protocol.v1.types.StringKeyAnyValue()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
};

/**
 * @returns number
 */
customAttributesLength():number {
  var offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
};

/**
 * @param number index
 * @param com.tableausoftware.endeavour.protocol.v1.types.StandardKeyAnyValue= obj
 * @returns com.tableausoftware.endeavour.protocol.v1.types.StandardKeyAnyValue
 */
standardAttributes(index: number, obj?:NS115100186165309685.com.tableausoftware.endeavour.protocol.v1.types.StandardKeyAnyValue):NS115100186165309685.com.tableausoftware.endeavour.protocol.v1.types.StandardKeyAnyValue|null {
  var offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? (obj || new NS115100186165309685.com.tableausoftware.endeavour.protocol.v1.types.StandardKeyAnyValue()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
};

/**
 * @returns number
 */
standardAttributesLength():number {
  var offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
};

/**
 * @param flatbuffers.Builder builder
 */
static startSpanCondition(builder:flatbuffers.Builder) {
  builder.startObject(3);
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Offset spanNameOffset
 */
static addSpanName(builder:flatbuffers.Builder, spanNameOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, spanNameOffset, 0);
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Offset customAttributesOffset
 */
static addCustomAttributes(builder:flatbuffers.Builder, customAttributesOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, customAttributesOffset, 0);
};

/**
 * @param flatbuffers.Builder builder
 * @param Array.<flatbuffers.Offset> data
 * @returns flatbuffers.Offset
 */
static createCustomAttributesVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (var i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]);
  }
  return builder.endVector();
};

/**
 * @param flatbuffers.Builder builder
 * @param number numElems
 */
static startCustomAttributesVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Offset standardAttributesOffset
 */
static addStandardAttributes(builder:flatbuffers.Builder, standardAttributesOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, standardAttributesOffset, 0);
};

/**
 * @param flatbuffers.Builder builder
 * @param Array.<flatbuffers.Offset> data
 * @returns flatbuffers.Offset
 */
static createStandardAttributesVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (var i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]);
  }
  return builder.endVector();
};

/**
 * @param flatbuffers.Builder builder
 * @param number numElems
 */
static startStandardAttributesVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
};

/**
 * @param flatbuffers.Builder builder
 * @returns flatbuffers.Offset
 */
static endSpanCondition(builder:flatbuffers.Builder):flatbuffers.Offset {
  var offset = builder.endObject();
  return offset;
};

static createSpanCondition(builder:flatbuffers.Builder, spanNameOffset:flatbuffers.Offset, customAttributesOffset:flatbuffers.Offset, standardAttributesOffset:flatbuffers.Offset):flatbuffers.Offset {
  SpanCondition.startSpanCondition(builder);
  SpanCondition.addSpanName(builder, spanNameOffset);
  SpanCondition.addCustomAttributes(builder, customAttributesOffset);
  SpanCondition.addStandardAttributes(builder, standardAttributesOffset);
  return SpanCondition.endSpanCondition(builder);
}
}
}
/**
 * @constructor
 */
export namespace com.tableausoftware.endeavour.protocol.v1.api{
export class ScrubbedAttribute {
  bb: flatbuffers.ByteBuffer|null = null;

  bb_pos:number = 0;
/**
 * @param number i
 * @param flatbuffers.ByteBuffer bb
 * @returns ScrubbedAttribute
 */
__init(i:number, bb:flatbuffers.ByteBuffer):ScrubbedAttribute {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param ScrubbedAttribute= obj
 * @returns ScrubbedAttribute
 */
static getRootAsScrubbedAttribute(bb:flatbuffers.ByteBuffer, obj?:ScrubbedAttribute):ScrubbedAttribute {
  return (obj || new ScrubbedAttribute()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param ScrubbedAttribute= obj
 * @returns ScrubbedAttribute
 */
static getSizePrefixedRootAsScrubbedAttribute(bb:flatbuffers.ByteBuffer, obj?:ScrubbedAttribute):ScrubbedAttribute {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new ScrubbedAttribute()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param flatbuffers.Encoding= optionalEncoding
 * @returns string|Uint8Array|null
 */
Name():string|null
Name(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
Name(optionalEncoding?:any):string|Uint8Array|null {
  var offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
};

/**
 * @returns com.tableausoftware.endeavour.protocol.v1.api.AttributeScrubbingMethod
 */
Method():com.tableausoftware.endeavour.protocol.v1.api.AttributeScrubbingMethod {
  var offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? /**  */ (this.bb!.readInt8(this.bb_pos + offset)) : com.tableausoftware.endeavour.protocol.v1.api.AttributeScrubbingMethod.Mask;
};

/**
 * @param flatbuffers.Builder builder
 */
static startScrubbedAttribute(builder:flatbuffers.Builder) {
  builder.startObject(2);
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Offset NameOffset
 */
static addName(builder:flatbuffers.Builder, NameOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, NameOffset, 0);
};

/**
 * @param flatbuffers.Builder builder
 * @param com.tableausoftware.endeavour.protocol.v1.api.AttributeScrubbingMethod Method
 */
static addMethod(builder:flatbuffers.Builder, Method:com.tableausoftware.endeavour.protocol.v1.api.AttributeScrubbingMethod) {
  builder.addFieldInt8(1, Method, com.tableausoftware.endeavour.protocol.v1.api.AttributeScrubbingMethod.Mask);
};

/**
 * @param flatbuffers.Builder builder
 * @returns flatbuffers.Offset
 */
static endScrubbedAttribute(builder:flatbuffers.Builder):flatbuffers.Offset {
  var offset = builder.endObject();
  return offset;
};

static createScrubbedAttribute(builder:flatbuffers.Builder, NameOffset:flatbuffers.Offset, Method:com.tableausoftware.endeavour.protocol.v1.api.AttributeScrubbingMethod):flatbuffers.Offset {
  ScrubbedAttribute.startScrubbedAttribute(builder);
  ScrubbedAttribute.addName(builder, NameOffset);
  ScrubbedAttribute.addMethod(builder, Method);
  return ScrubbedAttribute.endScrubbedAttribute(builder);
}
}
}
/**
 * @constructor
 */
export namespace com.tableausoftware.endeavour.protocol.v1.api{
export class ScrubbedAttributes {
  bb: flatbuffers.ByteBuffer|null = null;

  bb_pos:number = 0;
/**
 * @param number i
 * @param flatbuffers.ByteBuffer bb
 * @returns ScrubbedAttributes
 */
__init(i:number, bb:flatbuffers.ByteBuffer):ScrubbedAttributes {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param ScrubbedAttributes= obj
 * @returns ScrubbedAttributes
 */
static getRootAsScrubbedAttributes(bb:flatbuffers.ByteBuffer, obj?:ScrubbedAttributes):ScrubbedAttributes {
  return (obj || new ScrubbedAttributes()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param ScrubbedAttributes= obj
 * @returns ScrubbedAttributes
 */
static getSizePrefixedRootAsScrubbedAttributes(bb:flatbuffers.ByteBuffer, obj?:ScrubbedAttributes):ScrubbedAttributes {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new ScrubbedAttributes()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param flatbuffers.Encoding= optionalEncoding
 * @returns string|Uint8Array|null
 */
Name():string|null
Name(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
Name(optionalEncoding?:any):string|Uint8Array|null {
  var offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
};

/**
 * @param number index
 * @param com.tableausoftware.endeavour.protocol.v1.api.ScrubbedAttribute= obj
 * @returns com.tableausoftware.endeavour.protocol.v1.api.ScrubbedAttribute
 */
Attributes(index: number, obj?:com.tableausoftware.endeavour.protocol.v1.api.ScrubbedAttribute):com.tableausoftware.endeavour.protocol.v1.api.ScrubbedAttribute|null {
  var offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? (obj || new com.tableausoftware.endeavour.protocol.v1.api.ScrubbedAttribute()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
};

/**
 * @returns number
 */
AttributesLength():number {
  var offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
};

/**
 * @param flatbuffers.Builder builder
 */
static startScrubbedAttributes(builder:flatbuffers.Builder) {
  builder.startObject(2);
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Offset NameOffset
 */
static addName(builder:flatbuffers.Builder, NameOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, NameOffset, 0);
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Offset AttributesOffset
 */
static addAttributes(builder:flatbuffers.Builder, AttributesOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, AttributesOffset, 0);
};

/**
 * @param flatbuffers.Builder builder
 * @param Array.<flatbuffers.Offset> data
 * @returns flatbuffers.Offset
 */
static createAttributesVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (var i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]);
  }
  return builder.endVector();
};

/**
 * @param flatbuffers.Builder builder
 * @param number numElems
 */
static startAttributesVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
};

/**
 * @param flatbuffers.Builder builder
 * @returns flatbuffers.Offset
 */
static endScrubbedAttributes(builder:flatbuffers.Builder):flatbuffers.Offset {
  var offset = builder.endObject();
  return offset;
};

static createScrubbedAttributes(builder:flatbuffers.Builder, NameOffset:flatbuffers.Offset, AttributesOffset:flatbuffers.Offset):flatbuffers.Offset {
  ScrubbedAttributes.startScrubbedAttributes(builder);
  ScrubbedAttributes.addName(builder, NameOffset);
  ScrubbedAttributes.addAttributes(builder, AttributesOffset);
  return ScrubbedAttributes.endScrubbedAttributes(builder);
}
}
}
/**
 * @constructor
 */
export namespace com.tableausoftware.endeavour.protocol.v1.api{
export class GetPipelineConfigurationReply {
  bb: flatbuffers.ByteBuffer|null = null;

  bb_pos:number = 0;
/**
 * @param number i
 * @param flatbuffers.ByteBuffer bb
 * @returns GetPipelineConfigurationReply
 */
__init(i:number, bb:flatbuffers.ByteBuffer):GetPipelineConfigurationReply {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param GetPipelineConfigurationReply= obj
 * @returns GetPipelineConfigurationReply
 */
static getRootAsGetPipelineConfigurationReply(bb:flatbuffers.ByteBuffer, obj?:GetPipelineConfigurationReply):GetPipelineConfigurationReply {
  return (obj || new GetPipelineConfigurationReply()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param GetPipelineConfigurationReply= obj
 * @returns GetPipelineConfigurationReply
 */
static getSizePrefixedRootAsGetPipelineConfigurationReply(bb:flatbuffers.ByteBuffer, obj?:GetPipelineConfigurationReply):GetPipelineConfigurationReply {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new GetPipelineConfigurationReply()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param number index
 * @param com.tableausoftware.endeavour.protocol.v1.api.SpanCondition= obj
 * @returns com.tableausoftware.endeavour.protocol.v1.api.SpanCondition
 */
blockedSpans(index: number, obj?:com.tableausoftware.endeavour.protocol.v1.api.SpanCondition):com.tableausoftware.endeavour.protocol.v1.api.SpanCondition|null {
  var offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? (obj || new com.tableausoftware.endeavour.protocol.v1.api.SpanCondition()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
};

/**
 * @returns number
 */
blockedSpansLength():number {
  var offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
};

/**
 * @param number index
 * @param flatbuffers.Encoding= optionalEncoding
 * @returns string|Uint8Array
 */
blockedEvents(index: number):string
blockedEvents(index: number,optionalEncoding:flatbuffers.Encoding):string|Uint8Array
blockedEvents(index: number,optionalEncoding?:any):string|Uint8Array|null {
  var offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__string(this.bb!.__vector(this.bb_pos + offset) + index * 4, optionalEncoding) : null;
};

/**
 * @returns number
 */
blockedEventsLength():number {
  var offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
};

/**
 * @param number index
 * @param com.tableausoftware.endeavour.protocol.v1.api.ScrubbedAttributes= obj
 * @returns com.tableausoftware.endeavour.protocol.v1.api.ScrubbedAttributes
 */
scrubbedEventsAttributes(index: number, obj?:com.tableausoftware.endeavour.protocol.v1.api.ScrubbedAttributes):com.tableausoftware.endeavour.protocol.v1.api.ScrubbedAttributes|null {
  var offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? (obj || new com.tableausoftware.endeavour.protocol.v1.api.ScrubbedAttributes()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
};

/**
 * @returns number
 */
scrubbedEventsAttributesLength():number {
  var offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
};

/**
 * @param flatbuffers.Encoding= optionalEncoding
 * @returns string|Uint8Array|null
 */
endpoint():string|null
endpoint(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
endpoint(optionalEncoding?:any):string|Uint8Array|null {
  var offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
};

/**
 * @returns boolean
 */
revertBlockedToAllowedEvents():boolean {
  var offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
};

/**
 * @param flatbuffers.Builder builder
 */
static startGetPipelineConfigurationReply(builder:flatbuffers.Builder) {
  builder.startObject(5);
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Offset blockedSpansOffset
 */
static addBlockedSpans(builder:flatbuffers.Builder, blockedSpansOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, blockedSpansOffset, 0);
};

/**
 * @param flatbuffers.Builder builder
 * @param Array.<flatbuffers.Offset> data
 * @returns flatbuffers.Offset
 */
static createBlockedSpansVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (var i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]);
  }
  return builder.endVector();
};

/**
 * @param flatbuffers.Builder builder
 * @param number numElems
 */
static startBlockedSpansVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Offset blockedEventsOffset
 */
static addBlockedEvents(builder:flatbuffers.Builder, blockedEventsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, blockedEventsOffset, 0);
};

/**
 * @param flatbuffers.Builder builder
 * @param Array.<flatbuffers.Offset> data
 * @returns flatbuffers.Offset
 */
static createBlockedEventsVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (var i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]);
  }
  return builder.endVector();
};

/**
 * @param flatbuffers.Builder builder
 * @param number numElems
 */
static startBlockedEventsVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Offset scrubbedEventsAttributesOffset
 */
static addScrubbedEventsAttributes(builder:flatbuffers.Builder, scrubbedEventsAttributesOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, scrubbedEventsAttributesOffset, 0);
};

/**
 * @param flatbuffers.Builder builder
 * @param Array.<flatbuffers.Offset> data
 * @returns flatbuffers.Offset
 */
static createScrubbedEventsAttributesVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (var i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]);
  }
  return builder.endVector();
};

/**
 * @param flatbuffers.Builder builder
 * @param number numElems
 */
static startScrubbedEventsAttributesVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Offset endpointOffset
 */
static addEndpoint(builder:flatbuffers.Builder, endpointOffset:flatbuffers.Offset) {
  builder.addFieldOffset(3, endpointOffset, 0);
};

/**
 * @param flatbuffers.Builder builder
 * @param boolean revertBlockedToAllowedEvents
 */
static addRevertBlockedToAllowedEvents(builder:flatbuffers.Builder, revertBlockedToAllowedEvents:boolean) {
  builder.addFieldInt8(4, +revertBlockedToAllowedEvents, +false);
};

/**
 * @param flatbuffers.Builder builder
 * @returns flatbuffers.Offset
 */
static endGetPipelineConfigurationReply(builder:flatbuffers.Builder):flatbuffers.Offset {
  var offset = builder.endObject();
  return offset;
};

static createGetPipelineConfigurationReply(builder:flatbuffers.Builder, blockedSpansOffset:flatbuffers.Offset, blockedEventsOffset:flatbuffers.Offset, scrubbedEventsAttributesOffset:flatbuffers.Offset, endpointOffset:flatbuffers.Offset, revertBlockedToAllowedEvents:boolean):flatbuffers.Offset {
  GetPipelineConfigurationReply.startGetPipelineConfigurationReply(builder);
  GetPipelineConfigurationReply.addBlockedSpans(builder, blockedSpansOffset);
  GetPipelineConfigurationReply.addBlockedEvents(builder, blockedEventsOffset);
  GetPipelineConfigurationReply.addScrubbedEventsAttributes(builder, scrubbedEventsAttributesOffset);
  GetPipelineConfigurationReply.addEndpoint(builder, endpointOffset);
  GetPipelineConfigurationReply.addRevertBlockedToAllowedEvents(builder, revertBlockedToAllowedEvents);
  return GetPipelineConfigurationReply.endGetPipelineConfigurationReply(builder);
}
}
}
